import socketMachine from "./socketMachine";
import debugFactory from "debug";

const debug = debugFactory( "teaming:fsm:socket-machine" );

socketMachine.on( "*", debug );
socketMachine.on( "transitioned", () => {
	debug( `FSM state: ${ socketMachine.compositeState() }` );
} );
// Leaving here for diagnostics reference
// window.__SOCKETMACHINE = socketMachine;
// If you want to see the "composite" state of the parent (socketMachine)
// and child (messageMachine) while in connected state, you can run this
// in the browser console (assuming above lines are also un-commented):
// __SOCKETMACHINE.compositeState() // -> "connected.ready", for example

export const machine = socketMachine;

// Called once. (Currently called in schedule.vue, but should get moved to main.js soon)
export const connectToSocket = async () => {
	socketMachine.connect();
};

// stores (or store helper modules) should call this to add listeners
// for when SocketMessageTypes arrive via the WS connection
export const addSocketMessageListener = ( ...args ) => {
	return socketMachine.on( ...args );
};



// WEBPACK FOOTER //
// ./src/api/socketAPI/index.js